import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { inject } from '@angular/core';
import { AuthCustomService } from './auth-custom.service';
import { from, switchMap } from 'rxjs';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authCustom = inject(AuthCustomService);

  // Bypass para APIs externas
  if (req.url.includes('viacep.com.br') || req.url.includes('servicodados.ibge.gov.br') || req.url.includes('nominatim.openstreetmap.org')) {
    return next(req);
  }

  return from(authCustom.ensureToken()).pipe(
    switchMap((token) => {
      const api_url = environment.apiUrl;
      // Remove o basePath padrão se a URL começar com http://localhost:8080
      let cleanUrl = req.url;
      if (cleanUrl.startsWith('http://localhost:8080')) {
        cleanUrl = cleanUrl.replace('http://localhost:8080', '');
      }
      // Garante que a URL comece com /
      if (!cleanUrl.startsWith('/')) {
        cleanUrl = '/' + cleanUrl;
      }
      const request_url = api_url.replace(/\/$/, '') + cleanUrl;
      const intercepted = req.clone({
        url: request_url,
        ...(token
          ? {
              setHeaders: {
                Authorization: `Bearer ${token}`,
              },
            }
          : {}),
      });

      return next(intercepted);
    })
  );
};
